module.exports = __webpack_public_path__ + "static/media/pg.03d02d87.svg";